<template>
  <div class="keyboard-wrap h-100">
    <div class="amount">
      <cus-button
        v-for="num in [50, 100, 500, 1000]"
        :key="num"
        :text="num.toString()"
        @click="key = num"
        :disabled="!amountValid"
      ></cus-button>
    </div>
    <div class="number">
      <cus-button
        v-for="num in 9"
        :key="num"
        :text="num.toString()"
        :disabled="!numberValid"
        @click="handleNumber(`${num}`)"
      ></cus-button>
      <cus-button text="0" style="grid-area: 4/1/5/3" :disabled="!numberValid" @click="handleNumber('0')"></cus-button>
      <cus-button
        topIcon="arrow-left"
        topIconClass="back-arrow"
        :disabled="!numberValid"
        @click="handleBack"
      ></cus-button>
    </div>
  </div>
</template>
<script>
import { computed } from 'vue';
export default {
  name: 'keyboard',
  props: ['number', 'amountValid', 'numberValid'],
  emits: ['update:number'],
  setup(props, context) {
    const key = computed({
      get: () => props.number,
      set: (val) => context.emit('update:number', val),
    });
    //按數字
    const handleNumber = (num) => {
      let str_key = key.value ? key.value.toString() : '';
      key.value = str_key + num;
    };
    //消除數字
    const handleBack = () => {
      let str_key = key.value ? key.value.toString() : '';
      if (str_key.length === 1) {
        key.value = null;
      } else {
        key.value = str_key.slice(0, -1);
      }
    };
    return { key, handleNumber, handleBack };
  },
};
</script>
<style lang="scss" scoped>
.keyboard-wrap {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(4, 1fr);
}
.amount {
  grid-area: 1/1/5/2;
  display: grid;
  grid-template-rows: repeat(4, 1fr);
}
.number {
  grid-area: 1/2/5/5;
  display: grid;
  grid-template-rows: repeat(4, 1fr);
  grid-template-columns: repeat(3, 1fr);
}
</style>
